<div class="el-breadcrumb-wrapper">
  <div class="container">
    <div class="el-breadcrmb-inner">
      <h1>My Orders</h1>
      <ul>
        <li>

          <a style="color: #e04787;">
            <select class="form-control sf-select" [(ngModel)]="selectedStatus">
              <option value="All">All Orders</option>
              <option value="Success">Success Orders</option>
              <option value="Pending">Pending Orders</option>
            </select></a>
        </li>
        <li>
          <!-- <a style="color: #e04787;" class="custom-select">
            <select class="form-control sf-select" [(ngModel)]="selectedYear" (ngModelChange)="MyOrders()">
              <option value="" disabled hidden>Select Financial Year</option>
              <option *ngFor="let year of FYearList" [value]="year">{{ year }}</option>
            </select>
          </a> -->
        </li>
        <li><a class="el-btn text-white" [routerLink]=" ['/freemock']"><i class="fa fa-reply " aria-hidden="true"></i>
            &nbsp; Back</a></li>

      </ul>
    </div>
  </div>
</div>
<!-- Breadcrumb Start -->



<div class="el-blog-single-wrapper ">
  <div class="container">
    <div class="">
      <!-- Orders Display -->
      <div class=" gy-4 " *ngIf="filteredOrders().length > 0; else noDataTemplate">
        <div *ngFor="let item of filteredOrders()" class="el-inner-blog-box el-blog-single my-order">
          <!-- Order Header -->
          <div class=" ">
            <div class="row order-header">
              <div class="col-md-6 "> <span>
                  <h5 class="d-inline">Order No:</h5>
                </span><span> {{ item.orderNumber }}</span></div>
              <div class="col-md-6 text-md-end text-sm-start"> <span>
                  <h5 class="active d-inline">Date:</h5>
                  {{toUtc(item.orderDate) | date:'dd-MMM-yyyy, h:mm a':'+0530' }}
                  <!-- {{ item.orderDate | date:'yyyy-MM-dd HH:mm:ss' }} -->
                  <!-- {{ item.orderDate | date: 'yyyy-MM-dd HH:mm:ss':'UTC' }} -->
                  <!-- {{ item.orderDate | date: 'yyyy-MM-dd HH:mm:ss':'UTC' }} -->
                </span>
              </div>
            </div>


          </div>

          <hr>

          <!-- Book List in Order -->
          <div *ngFor="let book of item.orderDetails" class="row align-items-center mb-3  p-2 rounded-3">
            <div class="col-md-1 text-center">
              <img [src]="book.bookImage || 'https://placehold.co/400'" class="img-fluid rounded" alt="Book">
            </div>

            <div class="col-md-8">
              <div class="fw-bold">
                {{ book.itemDescription || 'No Title Available' }}
              </div>

              <!-- If Success -->
              <div *ngIf="item.payment_Status === 'Success'">
                <div class="mt-2">
                  <strong>INR {{ book.unitPrice || 0 }}</strong> &nbsp;&nbsp;
                  <span class="expiry-text" *ngIf="item.bookType == 4">
                    Valid till {{ book.expiryDate ? (book.expiryDate|date:'dd-MMM-yyyy' ): 'N/A' }}
                  </span>
                </div>

                <div class="mt-2" *ngIf="book.pdf_Path && item.bookType != 5">
                  <button type="button" [routerLink]="['/eBook']" class="btn btn-outline-success "
                    [queryParams]="{ id: book.pdf_Path | getPdfId, BookName: book.itemDescription }">
                    <i class="fa fa-book"></i> Read Now
                  </button>
                </div>

                <!-- <div class="mt-2" *ngIf="book.invoicePath">
                  <a [href]="book.invoicePath" class="btn btn-outline-secondary btn-sm" target="_blank">
                    <i class="fa fa-download"></i> Download Invoice
                  </a>
                </div> -->
              </div>

              <!-- If Not Success -->
              <!-- <div *ngIf="item.payment_Status !== 'Success'" class="text-muted mt-2">
                <div class="text-danger fw-bold mb-2">Payment Pending</div>
              </div> -->
              <div class="mt-2" *ngIf="item.payment_Status !== 'Success'">
                <strong>INR {{ book.unitPrice || 0 }}</strong> &nbsp;&nbsp;

              </div>

            </div>
          </div>

          <!-- Order Footer -->
          <div class="card-footer bg-white ">
            <div class="row">
              <div class="col-md-8 payment-status my-2"
                [ngClass]="{'text-success': item.payment_Status === 'Success','text-danger': item.payment_Status !== 'Success'}">
                <h5> Payment Status: {{ item.payment_Status }}</h5>
              </div>

              <div class="col-md-4 text-md-end text-sm-start fw-bold">
                <button class="btn btn-outline-primary  me-3"
                  *ngIf="item.payment_Status === 'Success' && item.bookType != 5 && item.bookType !=4 && item.bookType !=null"
                  (click)="trackOrder(item.id)">
                  <i class="fa fa-truck"></i> TrackOrder
                </button>
                <a *ngIf="item.payment_Status === 'Success'"
                  href="https://service.silverzone.org/api/School/AccountManagement/Print_Invoice?Currency=INR&OrderNumber={{item.orderNumber}}&IsDetails=true"
                  target="_blank" class="btn el-btn-outline"><i class="fa fa-print"></i> Invoice</a>
                <button class="btn el-btn-outline" (click)="payNow(item)" *ngIf="item.payment_Status !== 'Success'">
                  <i class="fa fa-credit-card"> </i>&nbsp; Pay Now
                </button>

                Total: INR {{ item.orderAmount }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- No Data Template -->




      <ng-template #noDataTemplate>

        <div class="d-flex justify-content-center" *ngIf="IsShowMessage">
          <div class="col-md-5 alert">
            <i class="fa fa-exclamation-triangle" aria-hidden="true" style="font-size: 50px;color: #e04787;"></i>
            <br><br>
            No Order Yet!
            <br><br>
            <a [routerLink]="['/product']">Please click here to <strong>Order Now</strong>.</a>
          </div>
        </div>

        <!-- <div class="text-center text-muted p-4">
          <strong>No orders found for "{{ selectedStatus }}"</strong>
        </div> -->
      </ng-template>


    </div>

    <!-- Modal -->
    <div class="modal fade" id="orderModal" tabindex="-1" aria-labelledby="orderModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="orderModalLabel">History</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
          </div>

          <div class="modal-body">
            <!-- Order Tracking History -->
            <div *ngIf="trackingHistory?.length">
              <h5 class="mb-3">Order Tracking History</h5>
              <table class="table table-bordered">
                <thead class="table-light">
                  <tr>
                    <th>Status</th>
                    <th>Remarks</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of trackingHistory">
                    <td>{{ item.orderStatus }}</td>
                    <td>{{ item.remarks || '—' }}</td>
                    <td>{{ item.creationDate | date: 'dd-MMM-yyyy, hh:mm a' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <hr>

            <!-- Courier Details -->
            <div *ngIf="courierDetails">
              <h5 class="mb-3">Courier Details</h5>
              <table class="table table-bordered">
                <tbody>
                  <tr>
                    <th>Courier Name</th>
                    <td>{{ courierDetails.courierName }}</td>
                  </tr>
                  <tr>
                    <th>Consignment No</th>
                    <td>{{ courierDetails.consignmentNo }}</td>
                  </tr>
                  <tr>
                    <th>Tracking Link</th>
                    <td>
                      <a [href]="courierDetails.courier_Link" target="_blank">Track Your Order</a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="modal-footer">
              <button type="button" class="el-btn btn-secondary" data-bs-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>